import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {DiscountApplicationMethodSettings} from '../types';

const getDiscountApplicationMethodResponseMock: DiscountApplicationMethodSettings = {
  applicationMethod: 'DISCOUNT_APPLICATION_ON_TOTAL_SELLING_PRICE',
  validities: [
    {roundType: 'ALGEBRAIC', roundStep: '0.01', validFrom: '2026-02-24'},
    {roundType: 'UP', roundStep: '0.01', validFrom: '2026-08-01'},
  ],
};

const getRoundStepResponseMock = [
  {key: '0.01', value: '0,01'},
  {key: '0.1', value: '0,1'},
  {key: '1', value: '1'},
];

const getDiscountApplicationMethodResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/discount-application-method', () =>
      HttpResponse.json(getDiscountApplicationMethodResponseMock)
    )
  );

const getEmptyDiscountApplicationMethodResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/core/v1/discount-application-method', () => new HttpResponse(null, {status: 204}))
  );

const putDiscountApplicationMethodResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.put('*/core/v1/discount-application-method', () => new HttpResponse(null, {status: 204}))
  );

const getRoundStepResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/dms/v1/rounding-definition/round-step', () =>
      HttpResponse.json(getRoundStepResponseMock)
    )
  );

export const metadaDiscountApplicationMethodApiMock = {
  getDiscountApplicationMethodResponseMock,
  getRoundStepResponseMock,
  getDiscountApplicationMethodResponseInterceptor,
  getEmptyDiscountApplicationMethodResponseInterceptor,
  putDiscountApplicationMethodResponseInterceptor,
  getRoundStepResponseInterceptor,
};
